{
  "$white": "#FFFFFF",
  "$base-80": "#FBF9F9",
  "$black": "#1F1F24",

  "$gray0": "#FFFFFF",
  "$gray1": "#F6F6F6",
  "$gray2": "#E9E9E9",
  "$gray3": "#8F8F91",
  "$gray4": "#626266",
  "$gray5": "#2A2A2F",
  "$gray6": "#9B9B9B",

  "$blue1": "#4F44E0",
  "$blue2": "#463DBB",
  "$blue3": "#322E6F",

  "$green1": "#219464",
  "$green2": "#217D57",
  "$green3": "#204E3E",

  "$red1": "#E34F2F",
  "$red2": "#BC452D",
  "$red3": "#6D3228",

  "$orange1": "#DF7800",
  "$orange2": "#B96607",
  "$orange3": "#6C4316",

  "$mint140": "#07B096",
  "$mint20": "#E0FAFA",

  "$light-mode-gray0": "#FFFFFF",
  "$light-mode-gray1": "#F6F6F6",
  "$light-mode-gray2": "#E9E9E9",
  "$light-mode-gray3": "#8F8F91",
  "$light-mode-gray4": "#626266",
  "$light-mode-gray5": "#2A2A2F",

  "$light-mode-blue1": "#4F44E0",
  "$light-mode-blue2": "#463DBB",
  "$light-mode-blue3": "#322E6F",

  "$light-mode-green1": "#219464",
  "$light-mode-green2": "#217D57",
  "$light-mode-green3": "#204E3E",

  "$light-mode-red1": "#E34F2F",
  "$light-mode-red2": "#BC452D",
  "$light-mode-red3": "#6D3228",

  "$light-mode-orange1": "#DF7800",
  "$light-mode-orange2": "#B96607",
  "$light-mode-orange3": "#6C4316",

  "$dark-mode-gray0": "#191919",
  "$dark-mode-gray1": "#28292C",
  "$dark-mode-gray2": "#3A3B3D",
  "$dark-mode-gray3": "#88898A",
  "$dark-mode-gray4": "#C7C7C8",
  "$dark-mode-gray5": "#F6F6F6",

  "$dark-mode-blue1": "#7B80FF",
  "$dark-mode-blue2": "#9291DE",
  "$dark-mode-blue3": "#B9B8EA",

  "$dark-mode-green1": "#26AB74",
  "$dark-mode-green2": "#33D28F",
  "$dark-mode-green3": "#5CDBA6",

  "$dark-mode-red1": "#E66347",
  "$dark-mode-red2": "#EC8974",
  "$dark-mode-red3": "#F2AFA1",

  "$dark-mode-orange1": "#FF8900",
  "$dark-mode-orange2": "#FFA133",
  "$dark-mode-orange3": "#FFB866",

  "$disabled-gray": "#DBDBDB",

  "$marketing-primary1": "#7856FF",
  "$marketing-primary2": "#9378FF",

  "$purple-20": "#E8DDFF",
  "$purple-40": "#B094FF",
  "$purple-140": "#5028C0",
  "$purple-200": "#1B0B3B",
  "$lava-100": "#ff7558",
  "$lava-140": "#cc332b",

  "$insights-icon": "#7856FF",
  "$funnels-icon": "#FF7557",
  "$flows-icon": "#F8BC3B",
  "$retention-icon": "#80E1D9",

  "$chart1": "#7856FF",
  "$chart2": "#FF7557",
  "$chart3": "#80E1D9",
  "$chart4": "#F8BC3B",
  "$chart5": "#B2596E",
  "$chart6": "#72BEF4",
  "$chart7": "#FFB27A",
  "$chart8": "#0D7EA0",
  "$chart9": "#3BA974",
  "$chart10": "#FEBBB2",
  "$chart11": "#CA80DC",
  "$chart12": "#5BB7AF",

  "$other-segment": "#BBB",
  "$other-segment-secondary": "#FFF",

  "$stat-sig-green": "#39D183",
  "$stat-sig-red": "#E4567B",

  "$positive-scale0": "#F3F6FB",
  "$positive-scale1": "#BDEAF8",
  "$positive-scale2": "#98DCF2",
  "$positive-scale3": "#51C7E4",
  "$positive-scale4": "#06B1D7",
  "$positive-scale5": "#0793D1",
  "$positive-scale6": "#0876CC",
  "$positive-scale7": "#0759C7",
  "$positive-scale8": "#093BC1",

  "$negative-scale0": "#F3F6FB",
  "$negative-scale1": "#FFF5CA",
  "$negative-scale2": "#FFE98A",
  "$negative-scale3": "#FFDE49",
  "$negative-scale4": "#FFD209",
  "$negative-scale5": "#F7BA0D",
  "$negative-scale6": "#EEA313",
  "$negative-scale7": "#E68B19",
  "$negative-scale8": "#DD731C",

  "$sequence-9": "rgba(120, 86, 255, 1)",
  "$sequence-8": "rgba(120, 86, 255, 0.9)",
  "$sequence-7": "rgba(120, 86, 255, 0.8)",
  "$sequence-6": "rgba(120, 86, 255, 0.7)",
  "$sequence-5": "rgba(120, 86, 255, 0.6)",
  "$sequence-4": "rgba(120, 86, 255, 0.5)",
  "$sequence-3": "rgba(120, 86, 255, 0.4)",
  "$sequence-2": "rgba(120, 86, 255, 0.3)",
  "$sequence-1": "rgba(120, 86, 255, 0.2)",
  "$sequence-0": "rgba(120, 86, 255, 0.1)"
}
